module.exports = __webpack_public_path__ + "img/logo.d2f933d6.png";